import { NewsletterTemplate } from "../types";

interface TemplateContentDisplayProps {
  template: NewsletterTemplate;
}

export const TemplateContentDisplay = ({ template }: TemplateContentDisplayProps) => {
  const renderContent = () => {
    if (!template.content_structure) {
      return <p className="text-sm text-muted-foreground">No content available</p>;
    }

    try {
      const content = template.content_structure;
      
      // Handle different template types
      switch (template.template_type) {
        case 'weekly':
          return (
            <>
              <h4 className="text-sm font-medium mb-2">Weekly Newsletter Structure:</h4>
              <ul className="list-disc pl-4 space-y-1">
                <li>Top Story of the Week</li>
                <li>Market Analysis</li>
                <li>Innovation Highlights</li>
                <li>Industry Updates</li>
                <li>Week Ahead Preview</li>
              </ul>
            </>
          );
        
        case 'daily':
          return (
            <>
              <h4 className="text-sm font-medium mb-2">Daily Newsletter Structure:</h4>
              <ul className="list-disc pl-4 space-y-1">
                <li>Top Headlines</li>
                <li>Market Pulse</li>
                <li>Technology Updates</li>
                <li>Company News</li>
                <li>Industry Insights</li>
              </ul>
            </>
          );

        case 'welcome':
          return (
            <>
              <h4 className="text-sm font-medium mb-2">Welcome Sequence Content:</h4>
              <ul className="list-disc pl-4 space-y-1">
                <li>Platform Introduction</li>
                <li>Newsletter Benefits</li>
                <li>Getting Started Guide</li>
                <li>Preference Settings</li>
                <li>Community Guidelines</li>
              </ul>
            </>
          );

        case 'monthly':
          return (
            <>
              <h4 className="text-sm font-medium mb-2">Monthly Preview Structure:</h4>
              <ul className="list-disc pl-4 space-y-1">
                <li>New EV Releases</li>
                <li>Market Trends</li>
                <li>Technology Innovations</li>
                <li>Industry Analysis</li>
                <li>Future Outlook</li>
              </ul>
            </>
          );

        default:
          if (typeof content.template === 'string') {
            try {
              const parsed = JSON.parse(content.template);
              return (
                <pre className="text-sm text-muted-foreground whitespace-pre-wrap max-h-32 overflow-y-auto">
                  {JSON.stringify(parsed, null, 2)}
                </pre>
              );
            } catch {
              return (
                <p className="text-sm text-muted-foreground">
                  {content.template}
                </p>
              );
            }
          }
          return <p className="text-sm text-muted-foreground">Template structure not available</p>;
      }
    } catch (error) {
      console.error('Error rendering template content:', error);
      return <p className="text-sm text-muted-foreground">Error displaying content</p>;
    }
  };

  return (
    <div className="mt-4 p-4 bg-muted rounded-md">
      <p className="text-sm font-medium mb-2">Template Content:</p>
      {renderContent()}
    </div>
  );
};